module.exports = __webpack_public_path__ + "static/media/trees.84f63483.svg";